import { getQueryPrefix } from 'modules/utils/queryString';
import qs from 'qs';
import { ImageResize } from 'types/common/imageResize';

export const getImageSize = (file: File): number => {
  return file?.size ?? 0;
};

export const getImageResolution = (file: File): Promise<{ width: number; height: number }> => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = URL.createObjectURL(file);
    img.onload = () => {
      resolve({ width: img.width, height: img.height });
      URL.revokeObjectURL(img.src);
    };
    img.onerror = reject;
  });
};

const regexHttpPattern = /^https?:\/\//i;

// [EN] Single encoder of the CDN resize query. Normalizes scheme-less API paths
//      (resizingImageUrl delegates here for its http inputs). resize=1 is required
//      by the CDN to resize extension-less paths, so it is defaulted here rather
//      than trusted to every caller.
// [KO] CDN 리사이즈 쿼리의 단일 인코더. 프로토콜 없는 API 경로의 스킴을 보정한다
//      (resizingImageUrl 도 http 입력을 여기로 위임). resize=1 은 확장자 없는
//      경로의 리사이즈에 CDN 이 요구하는 값이라, 호출부에 맡기지 않고 여기서
//      기본값으로 넣는다.
export const generateResizedImageUrl = (imgSrc: string, resize: ImageResize): string => {
  // Empty input would become 'https://', which new URL() rejects — return as-is
  if (!imgSrc) {
    return imgSrc;
  }
  const imgUrl = regexHttpPattern.test(imgSrc) ? imgSrc : `https://${imgSrc}`;
  return `${imgUrl}${getQueryPrefix(imgUrl)}${qs.stringify({ resize: '1', ...resize })}`;
};

export const generateThumbnailUrls = (
  imgSrc: string,
  displayHeight?: number,
  placeholderHeight?: number,
): {
  displayImageURL: string;
  placeholderImageURL: string;
} => {
  const displayImageURL = generateResizedImageUrl(imgSrc, { h: displayHeight ?? 240 });
  const placeholderImageURL = generateResizedImageUrl(imgSrc, { h: placeholderHeight ?? 60 });

  return { displayImageURL, placeholderImageURL };
};
